import { Box, Grid } from "@mui/material";
import { FC, useState, useEffect } from "react";
import { H3, H4, H5 } from "../../components/Typography";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CustomButton from "../../components/CustomButton";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import {
  redeemOrderStatus,
  giftingStatusApi,
} from "../../redux/actions/GoldSilverAction";
import { load, remove } from "../../constants/storage";
import { Player } from "@lottiefiles/react-lottie-player";
import Success from "../../assets/Lottifies/sucessPayment.json";
import Pending from "../../assets/Lottifies/pending.json";
import Failed from "../../assets/Lottifies/failed.json";
import moment from "moment";
import { GSPOTOrderStatus } from "../../redux/actions/GoalAction";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
const PaymentSuccess: FC = () => {
  let navigate = useNavigate();
  let routeData = useLocation();
  const dispatch = useAppDispatch();
  const { orderid } = routeData.state;
  const [data, setData] = useState<any>();
  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      orderIdCheck();
    }
  };
  const [loading, setLoading] = useState(true);
  const [txtType, setTxnType] = useState("");

  const orderIdCheck = () => {
    if (orderid.includes("JOY")) {
      giftOrderStatus();
      return;
    } else if (orderid.includes("POTS")) {
      GSPotCheckAPI();
    } else {
      getOrderStatus();
    }
  };
  const getOrderStatus = async () => {
    let token: any = await load("token");
    var finalData: any = {
      orderId: orderid,
    };
    await dispatch(redeemOrderStatus(finalData, token))
      .then((response: any) => {
        console.log(response);
        {
          response.orderId.includes("SELF")
            ? setTxnType("Invested")
            : response.orderId.includes("COIN")
            ? setTxnType("Coin Purchased")
            : response.orderId.includes("REDEEM")
            ? setTxnType("Redeemed")
            : setTxnType("Gift sent");
        }

        setData(response);
        setLoading(false);
        if (
          response.status === "TXN_SUCCESS" ||
          response.status === "Executed"
        ) {
          setData(response);
          setLoading(false);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const giftOrderStatus = async () => {
    let token: any = await load("token");
    var finalData = JSON.stringify({
      orderId: orderid,
    });
    await dispatch(giftingStatusApi(finalData, token))
      .then((response: any) => {
        setData(response);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const GSPotCheckAPI = async () => {
    let token: any = await load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    var finalData = JSON.stringify({
      orderId: orderid,
      userId: finalUser.id,
    });
    await dispatch(GSPOTOrderStatus(finalData, token))
      .then((response: any) => {
        console.log("-0-0-00000000", response);
        if (response?.statusCode === 200) {
          setData(response.data);
          setTxnType("POTS");
          setLoading(false);
          return;
        }
        if (response?.statusCode === 400) {
          setLoading(false);
          return;
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };

  const convertTimeDate = (value: any) => {
    if (value == null) {
      return "--";
    } else {
      let date = new Date(value);
      let transactionDate = moment(date).format("DD MMM YYYY hh:mm A");

      return transactionDate;
    }
  };
  const currentDateTime = new Date().toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  console.log("------Data", data);
  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : txtType === "Invested" ? (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          height={"100vh"}
        >
          <Player
            autoplay
            loop
            src={
              data.status === "INITIATED"
                ? Pending
                : data.status === "FAILED"
                ? Failed
                : Success
            }
            style={{
              height: data.status === "INITIATED" ? "200px" : "300px",
              width: data.status === "INITIATED" ? "200px" : "300px",
            }}
          />
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
              color:
                data?.status === "TXN_SUCCESS"
                  ? "#008000"
                  : data?.status === "TXN_FAILURE"
                  ? "#f00"
                  : data?.status === "Executed"
                  ? "#008000"
                  : "#FFBF00",
            }}
          >
            {data?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : data?.status === "TXN_FAILURE"
              ? "Transaction Failed"
              : data?.status === "Executed"
              ? "Transaction Successful"
              : "Transaction Pending"}
          </H3>

          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
              borderRadius: "12px",
              background: "#ffff",
              width: {
                md: "30%",
                xs: "90%",
              },
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              mt: 1.5,
              mb: 1,
            }}
          >
            <Box
              component="img"
              src={
                data?.productId === "gold" || data?.giftType
                  ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                  : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
              }
              sx={sxStyleImage}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {data?.productId === "gold" ? "Gold" : "Silver"}
            </H4>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Order ID: {data?.orderId}
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,

                color: "#595959",
              }}
            >
              Weight : {data?.quantity} Gm
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                pb: 2,
                color: "#595959",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CalendarMonthIcon
                style={{
                  color: "#595959",
                  fontSize: "1.2rem",
                  marginRight: 5,
                }}
              />
              {convertTimeDate(data?.transactionTime)}
            </H5>
          </Box>
          <CustomButton
            title="Back to Home"
            onPress={() => navigate("/dashboard")}
            width={"30%"}
            sWidth={"90%"}
          />
        </Box>
      ) : txtType === "Coin Purchased" ? (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          height={"100vh"}
        >
          <Player
            autoplay
            loop
            src={
              data.status === "INITIATED"
                ? Pending
                : data.status === "FAILED"
                ? Failed
                : Success
            }
            style={{
              height: data.status === "INITIATED" ? "200px" : "300px",
              width: data.status === "INITIATED" ? "200px" : "300px",
            }}
          />
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
              color:
                data?.status === "TXN_SUCCESS"
                  ? "#008000"
                  : data?.status === "TXN_FAILURE"
                  ? "#f00"
                  : data?.status === "Executed"
                  ? "#008000"
                  : "#FFBF00",
            }}
          >
            {data?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : data?.status === "TXN_FAILURE"
              ? "Transaction Failed"
              : data?.status === "Executed"
              ? "Transaction Successful"
              : "Transaction Pending"}
          </H3>

          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
              borderRadius: "12px",
              background: "#ffff",
              width: {
                md: "30%",
                xs: "90%",
              },
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              mt: 1.5,
              mb: 1,
            }}
          >
            <Box
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/coin.svg"
              sx={{
                height: 100,
                width: 110,
                mt: 2,
              }}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {"Gold Coin"}
            </H4>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Order ID: {data?.orderId}
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Weight : {data?.quantity} Gm
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                pb: 2,
                color: "#595959",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CalendarMonthIcon
                style={{
                  color: "#595959",
                  fontSize: "1.2rem",
                  marginRight: 5,
                }}
              />
              {convertTimeDate(data?.transactionTime)}
            </H5>
          </Box>
          <CustomButton
            title="Back to Home"
            onPress={() => navigate("/dashboard")}
            width={"30%"}
            sWidth={"90%"}
          />
        </Box>
      ) : txtType === "Redeemed" ? (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          height={"100vh"}
        >
          <Player
            autoplay
            loop
            src={
              data.status === "INITIATED"
                ? Pending
                : data.status === "FAILED"
                ? Failed
                : Success
            }
            style={{
              height: data.status === "INITIATED" ? "200px" : "300px",
              width: data.status === "INITIATED" ? "200px" : "300px",
            }}
          />
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
              color:
                data?.status === "TXN_SUCCESS"
                  ? "#008000"
                  : data?.status === "TXN_FAILURE"
                  ? "#f00"
                  : data?.status === "Executed"
                  ? "#008000"
                  : "#FFBF00",
            }}
          >
            {data?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : data?.status === "TXN_FAILURE"
              ? "Transaction Failed"
              : data?.status === "Executed"
              ? "Transaction Successful"
              : "Transaction Pending"}
          </H3>

          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
              borderRadius: "12px",
              background: "#ffff",
              width: {
                md: "30%",
                xs: "90%",
              },
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              mt: 1.5,
              mb: 1,
            }}
          >
            <Box
              component="img"
              src={
                data?.productId || data?.giftType === "gold"
                  ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                  : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
              }
              sx={{
                height: 100,
                width: 100,
                mt: 2,
              }}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {data?.productId || data?.giftType === "gold"
                ? "Gold Coin"
                : "Silver Coin"}
            </H4>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Order ID: {data?.orderId}
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,

                color: "#595959",
              }}
            >
              Weight : {data?.quantity} Gm
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                pb: 2,
                color: "#595959",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CalendarMonthIcon
                style={{
                  color: "#595959",
                  fontSize: "1.2rem",
                  marginRight: 5,
                }}
              />
              {convertTimeDate(data?.transactionTime)}
            </H5>
          </Box>
          <CustomButton
            title="Back to Home"
            onPress={() => navigate("/dashboard")}
            width={"30%"}
            sWidth={"90%"}
          />
        </Box>
      ) : txtType === "POTS" ? (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          height={"100vh"}
        >
          <Player
            autoplay
            loop
            src={data.status === "TXN_SUCCESS" ? Success : Pending}
            style={{
              height: data.status === "INITIATED" ? "200px" : "300px",
              width: data.status === "INITIATED" ? "200px" : "300px",
            }}
          />
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
              color:
                data?.status === "TXN_SUCCESS"
                  ? "#008000"
                  : data?.status === "TXN_FAILURE"
                  ? "#f00"
                  : data?.status === "Executed"
                  ? "#008000"
                  : "#FFBF00",
            }}
          >
            {data?.status === "TXN_SUCCESS"
              ? "Congratulations on successfully creating your goal"
              : data?.status === "TXN_FAILURE"
              ? "Your goal creation is currently in progress"
              : "Your goal creation is currently in progress"}
          </H3>

          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
              borderRadius: "12px",
              background: "#ffff",
              width: {
                md: "30%",
                xs: "90%",
              },
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              mt: 1.5,
              mb: 1,
            }}
          >
            <Box
              component="img"
              src={
                data?.productId === "gold"
                  ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                  : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
              }
              sx={sxStyleImage}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {data?.productId === "gold" ? "Gold" : "Silver"}
            </H4>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Order ID: {data?.txnId}
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,

                color: "#595959",
              }}
            >
              Weight : {data?.quantity} Gm
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                pb: 2,
                color: "#595959",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CalendarMonthIcon
                style={{
                  color: "#595959",
                  fontSize: "1.2rem",
                  marginRight: 5,
                }}
              />
              {convertTimeDate(data?.createdAt)}
            </H5>
          </Box>
          <CustomButton
            title="Back to Home"
            onPress={() => navigate("/dashboard")}
            width={"30%"}
            sWidth={"90%"}
          />
        </Box>
      ) : (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
          height={"100vh"}
        >
          <Player
            autoplay
            loop
            src={
              data.status === "INITIATED"
                ? Pending
                : data.status === "FAILED"
                ? Failed
                : Success
            }
            style={{
              height: data.status === "INITIATED" ? "200px" : "300px",
              width: data.status === "INITIATED" ? "200px" : "300px",
            }}
          />
          <H3
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
              color:
                data?.status === "TXN_SUCCESS"
                  ? "#008000"
                  : data?.status === "TXN_FAILURE"
                  ? "#f00"
                  : data?.status === "Executed"
                  ? "#008000"
                  : "#FFBF00",
            }}
          >
            {data?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : data?.status === "TXN_FAILURE"
              ? "Transaction Failed"
              : data?.status === "Executed"
              ? "Transaction Successful"
              : "Transaction Pending"}
          </H3>

          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
              borderRadius: "12px",
              background: "#ffff",
              width: {
                md: "30%",
                xs: "90%",
              },
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              mt: 1.5,
              mb: 1,
            }}
          >
            <Box
              component="img"
              src={
                data?.productId || data?.giftType === "gold"
                  ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                  : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
              }
              sx={sxStyleImage}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {data?.productId || data?.giftType === "gold" ? "Gold" : "Silver"}
            </H4>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                color: "#595959",
              }}
            >
              Order ID: {data?.orderId}
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,

                color: "#595959",
              }}
            >
              Weight : {data?.quantity} Gm
            </H5>
            <H5
              fontSize={12}
              fontWeight={"400"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 0.5,
                pb: 2,
                color: "#595959",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <CalendarMonthIcon
                style={{
                  color: "#595959",
                  fontSize: "1.2rem",
                  marginRight: 5,
                }}
              />
              {currentDateTime}
            </H5>
          </Box>
          <CustomButton
            title="Back to Home"
            onPress={() => navigate("/dashboard")}
            width={"30%"}
            sWidth={"90%"}
          />
        </Box>
      )}
    </>
  );
};

export default PaymentSuccess;
const sxStyleImage = {
  height: 80,
  width: 80,
  mt: 2,
};
